<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">할인차량관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">무료차량 관리</p>
					<ul class="depth">
						<li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
						<li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">무료차량 조회</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>무료차량 조회 테이블</caption>
                            <colgroup>
                                <col style="width:15%; min-width: 80px;"/>
                                <col style="width:auto"/>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">사용자명</th>
                                    <td>{{freeCar.carOwnerNm}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">차량번호</th>
                                    <td>{{freeCar.carNo}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">대상 주차장</th>
                                    <td v-if="freeCar.parkingRegDiv == 'PRD-001'">{{freeCar.parkingNm}}</td>
                                    <td v-else-if="freeCar.parkingRegDiv == 'PRD-002'">전체</td>
                                    <td v-else-if="freeCar.parkingRegDiv == 'PRD-003'">부설 주차장(가산금 없는 주차장)</td>
                                </tr>
                                <tr>
                                    <th scope="row">무료유형</th>
                                    <td>{{freeCar.freeTyNm}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">소속</th>
                                    <td>{{freeCar.orgNm}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">적용요일</th>
                                    <td>{{applyDay.toString()}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">무료기간</th>
                                    <td>{{freeCar.startDt}} - {{freeCar.endDt}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">비고</th>
                                    <td>{{freeCar.freeNote}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--//table-->

                </article>
                <article class="btnArea">
                    <button type="button" class="btn border" @click="$router.push('freevehicle')">목록</button>
                    <button type="button" class="btn gray" @click="deleteConfirm">삭제</button>
                    <button type="button" class="btn blue" @click="update">수정</button>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";

export default {
	data(){
		return{
            carId: "",
            freeCar: {},
            applyDay: [],
            paramApplyDay: '',
		}
    },
	
	mounted(){
        const carId = this.$route.query.freeCarId;
        if(!carId) {
			alert("잘못된 접근입니다.");
			this.$router.push('/freevehicle');
        }
        this.carId = carId;
        this.findFreeCar();
	},

    methods: {
        async findFreeCar() {
            const res = await axios('get', "/api/admin/freecar/view.json", {
                freeCarId: this.carId
            });
            this.freeCar = res.data.resultVo.result;
            if(this.freeCar?.applyDay) {
                this.paramApplyDay = this.freeCar.applyDay;
            }
            for(let i=0;i<this.freeCar.applyDay.toString().length;i++) {
                switch (this.freeCar.applyDay.toString().slice(i,i+1)) {
                    case '1':
                        this.applyDay.push('일');
                        break;
                    case '2':
                        this.applyDay.push('월');
                        break;
                    case '3':
                        this.applyDay.push('화');
                        break;
                    case '4':
                        this.applyDay.push('수');
                        break;
                    case '5':
                        this.applyDay.push('목');
                        break;
                    case '6':
                        this.applyDay.push('금');
                        break;
                    case '7':
                        this.applyDay.push('토');
                        break;
                }
            }
        },

        update() {
            const params = {
				freeCarId : this.freeCar.freeCarId,
				carOwnerNm : this.freeCar.carOwnerNm,
				orgNm : this.freeCar.orgNm,
				carNo : this.freeCar.carNo,
				sectnId : this.freeCar.sectnId,
				startDt : this.freeCar.startDt,
				endDt : this.freeCar.endDt,
				freeNote : this.freeCar.freeNote,
                applyDay : this.paramApplyDay,
                fctCode : this.freeCar.freeTyCd,
                parkingRegDiv : this.freeCar.parkingRegDiv,
			}
            this.$router.push({
				name : 'freevehicleupdate',
				params : {data : params}
			})
        },

		deleteConfirm(){
			this.$confirm(
				{
					message: `삭제하시겠습니까?`,
					button: {
						no: '아니오',
						yes: '예'
					},
					callback: confirm => {
						if (confirm) {
						this.deleteBtn();
						}
					}
				}
			)
        },

        async deleteBtn(){
			let apiParams = new FormData();
            apiParams.append("freeCarId", this.carId);
            await axios('post', "/api/admin/freecar/delete.json", apiParams);
            this.$router.push('freevehicle');
		},
	},

    computed: {
        numOfPages() {
			return Math.ceil(this.listData.length / this.dataPerPage);
		},
    }

}
</script>

